export default class NullPlenty {
  bindEvents(){
  }
}
